import styled from "@emotion/styled";

export const StyledButtonTab = styled.div`
  display: flex;
  align-items: center;
`;
